import styles from './Layout.module.css';
import React, { useEffect } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import useAuth from 'e3-common/hooks/useAuth';
import {
    setLocalStorageItem,
    getLocalStorageItem,
    removeLocalStorageItem, getSessionStorageItem,
} from 'e3-common/utils/localStorageUtil';
import { LOCAL_STORAGE_KEYS, PAGE_RENDER_TYPE } from 'e3-common/constants/enumerates';
import TopMenu from './TopMenu';
import SideMenu from './SideMenu';
import { useBoundStore } from 'e3-common/store/useBoundStore';
import { useNavigate } from 'react-router-dom';

const Layout = () => {
    const outlet = useOutlet();
    const { pageRenderType } = useBoundStore((state) => state.menu);
    const accessToken = getSessionStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    const userId = useBoundStore((state) => state.user.userId);

    const { refresh, azureSecure } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Azure 로그인인 경우 refresh를 타지 않음
        if (location.pathname && location.pathname.indexOf('AzureSecure') > -1) {
            azureSecure(location);
        } else if (accessToken && !userId && location) {
            refresh(location.pathname);
        }
    }, [userId, location]);

    useEffect(() => {
        if (!!location) {
            // 도메인입력 + 라우터 경로를 입력했을 때
            if (location.pathname !== import.meta.env.VITE_PUBLIC_URL + '/') {
                // 토큰이 있다면 입력된 라우터 경로로 이동
                if (accessToken) {
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH, location.search);
                    navigate(location.pathname + location.search);
                }
                // 토큰이 없다면
                else {
                    // 로컬 스토리지에 입력된 경로를 저장 후 로그인 페이지로 이동
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.PATH_NAME, location.pathname);
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH, location.search);
                    navigate(import.meta.env.VITE_PUBLIC_URL + `/login`);
                }
            }
            // 도메인만 입력했을 때
            else {
                // 토큰이 없다면 로그인 페이지로 이동
                if (!accessToken) {
                    removeLocalStorageItem(LOCAL_STORAGE_KEYS.PATH_NAME);
                    removeLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH);
                    navigate(import.meta.env.VITE_PUBLIC_URL + `/login`);
                }
            }
        }
    }, []);

    return (
        <div className={styles.wrap}>
            {!accessToken ? <></> : <TopMenu />}
            {!accessToken ? <></> : <SideMenu />}
            <div
                className={styles.contents}
                style={{
                    marginLeft: '0px',
                    ...(pageRenderType === PAGE_RENDER_TYPE.PAGE ? { padding: '0px 30px' } : null),
                }}
            >
                {outlet}
            </div>
        </div>

        // <div>
        // <TopMenu />
        // <div className={styles.container}>
        //   <div className={styles.wrap}>
        //     <div className={styles.layout}>
        //       <SideMenu />
        //       <div className={styles.contents} style={{marginLeft:'-35px'}}>{outlet}</div>
        //     </div>
        //   </div>
        // </div>
        // <Footer />
        // </div>
    );
};

Layout.displayName = 'Layout';
export default Layout;
